import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const removeChargeInstanceDebtor = async ({
    token,
    jsonData,
}) => {

    try {
        const res = await axiosCreate.put('/charge/instance/debtor/remove', jsonData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}

/**
 * jsonData:{
    "place_id": 1751,
    "charge_instance_id": 12
}
 * 
 */